import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import React from 'react';

import EditorPanel from './ssEditorPanel';
import RuntimePanel from './ssRuntimePanel';
import { useFormSelector } from '../../../custom-hooks';
import ControlChangesIcon from '../../components/ControlChangesIcon';
import { FCM_CONTAINER_STYLES } from '../../constants/runtime.constants';
import { getIsFormChangesMode } from '../../selectors/common.selectors';
import { isChildrenHidden, isPanelWithButtons } from '../../selectors/runtime.selectors';

const useStyles = makeStyles(FCM_CONTAINER_STYLES);

const SSPanel = ({
  isEditor,
  isControlHiddenFCM,
  isControlAddedFCM,
  isControlChangedFCM,
  ...props
}) => {
  const { id, index } = props;
  const classes = useStyles({ isControlAddedFCM });
  const childrenHidden = useFormSelector(isChildrenHidden, { id, index });
  const isFormChangesMode = useFormSelector(getIsFormChangesMode);
  const childrenButtons = useFormSelector(isPanelWithButtons, { id });

  if (isEditor) {
    return <EditorPanel {...props} />;
  }

  if ((childrenHidden && !isFormChangesMode) || childrenButtons) {
    return null;
  }

  if (isControlAddedFCM || isControlChangedFCM) {
    return (
      <div className={classes.changesModeWrapper} data-ss-id={id}>
        <div
          className={classNames(classes.control, isControlHiddenFCM ? classes.hiddenControl : '')}
          data-hidden-fcm={isControlHiddenFCM}
        >
          <RuntimePanel {...props} />
        </div>
        {isControlChangedFCM && (
          <div className={classes.changesIcon}>
            <ControlChangesIcon id={props.id} />
          </div>
        )}
      </div>
    );
  }

  if (isControlHiddenFCM) {
    return (
      <div className={classes.hiddenControl} data-hidden-fcm="true">
        <RuntimePanel {...props} />
      </div>
    );
  }

  return <RuntimePanel {...props} />;
};

export default SSPanel;
